<template>
  <div class="add-datasource-step2">
    <p class="add-datasouce-title">{{ $t('shu-ju-yuan-xin-xi') }}</p>
    <p class="add-datasource-basic">
      <span class="add-datasource-basic-label">{{ $t('bu-shu-lei-xing') }}</span><span
      class="add-datasource-basic-value">{{
        Mapping.cloudOrIdcName[addDataSourceForm.instanceType]
      }}</span><span
      class="add-datasource-basic-label">{{ $t('yuan-ku-lei-xing') }}</span><span
      class="add-datasource-basic-value">{{
        addDataSourceForm.instanceType === 'ALIBABA_CLOUD_HOSTED' ? Mapping.aliyunType[addDataSourceForm.type] : addDataSourceForm.type
      }}</span>
    </p>
    <p class="add-datasource-basic">
      <span class="add-datasource-basic-label">{{ $t('di-qu') }}</span><span
      class="add-datasource-basic-value">{{ addDataSourceForm.region }}</span>
    </p>
    <p class="add-datasouce-title">{{ $t('chuang-jian-zhang-hao-mi-ma') }}</p>
    <Table border
           :columns="getSecurity(addDataSourceForm.rdsList[0].securityType).needExtraAliyunAkSk?dataSourceColumnWithAkSk:dataSourceColumn"
           :data="addDataSourceForm.rdsList">
      <template slot-scope="{index}" slot="securityType">
        <Select v-model="addDataSourceForm.rdsList[index].securityType" style="width:160px"
                @on-change="handleUpdateAddForm" transfer>
          <Option v-for="security in securitySetting" :value="security.securityType"
                  :key="security.securityType">
            {{ Mapping.securityType[security.securityType] }}
          </Option>
        </Select>
      </template>
      <template slot-scope="{index}" slot="aliyunAKSK">
        <span>AK </span>
        <Input size="small" v-model="addDataSourceForm.rdsList[index].accessKey"
               style="width: 200px;margin-left: 6px"/>
        <span style="margin-left: 16px">SK </span>
        <Input size="small" v-model="addDataSourceForm.rdsList[index].secretKey"
               style="width: 200px;margin-left: 6px" password type="password"/>
      </template>
      <template slot-scope="{row,index}" slot="account">
        <div>
                <span
                  v-if="getSecurity(addDataSourceForm.rdsList[index].securityType).needUserName&&!getSecurity(addDataSourceForm.rdsList[index].securityType).accountAliyunAkSk">
                    <span>{{ $t('zhang-hao') }}</span>
                    <Input :disabled="row.autoCreate" size="small"
                           v-model="addDataSourceForm.rdsList[index].account"
                           style="width: 160px;margin-left: 6px"/>
                </span>
          <span v-if="getSecurity(addDataSourceForm.rdsList[index].securityType).needPassword&&!getSecurity(addDataSourceForm.rdsList[index].securityType).accountAliyunAkSk">
                    <span style="margin-left: 16px">{{ $t('mi-ma') }}</span>
                    <Input :disabled="row.autoCreate" size="small"
                           v-model="addDataSourceForm.rdsList[index].password"
                           style="width: 160px;margin-left: 6px" password type="password"/>
                </span>
          <span v-if="getSecurity(addDataSourceForm.rdsList[index].securityType).accountAliyunAkSk">
                    <span>AK</span>
                    <Input :disabled="row.autoCreate" size="small"
                           v-model="addDataSourceForm.rdsList[index].account"
                           style="width: 200px" :placeholder="$t('qing-shu-ruali-yun-accesskey-id')"/>
                    <span style="margin-left: 16px">SK</span>
                    <Input :disabled="row.autoCreate" size="small"
                           v-model="addDataSourceForm.rdsList[index].password"
                           style="width: 200px" password type="password"
                           :placeholder="$t('qing-shu-ruali-yun-accesskey-secret')"/>
                </span>
          <span
            v-if="getSecurity(addDataSourceForm.rdsList[index].securityType).needClientTrustStorePassword">
                    <span>{{ $t('ke-hu-duan-truststore-mi-ma') }}</span>
                    <Input :disabled="row.autoCreate" size="small"
                           v-model="addDataSourceForm.rdsList[index].clientTrustStorePassword"
                           style="width: 200px" :placeholder="$t('qing-shu-ru-ke-hu-duan-truststore-mi-ma')"/>
                </span>
          <input v-if="getSecurity(addDataSourceForm.rdsList[index].securityType).needTlsFile"
                 @change="handleFileChange(index,$event)" type="file" name="uploadfile"
                 id="uploadfile1"/>
<!--          <Checkbox-->
<!--            v-if="getSecurity(addDataSourceForm.rdsList[index].securityType).hasAutoCreateAccountOption"-->
<!--            style="margin-left: 4px" v-model="row.autoCreate"-->
<!--            @on-change="handleChangeAuto(index,$event)">{{ $t('zi-dong-chuang-jian') }}-->
<!--          </Checkbox>-->
        </div>
      </template>
    </Table>
  </div>
</template>
<script>
import Mapping from '@/views/util';
import DataSourceGroup from '@/views/dataSourceGroup';
import store from '@/store/index';

export default {
  props: {
    addDataSourceForm: Object,
    securitySetting: Array
  },
  created() {
    if (store.state.firstAddDataSource) {
      if (DataSourceGroup.mysql.indexOf(this.addDataSourceForm.type) > -1 || DataSourceGroup.drds.indexOf(this.addDataSourceForm.type) > -1) {
        this.addDataSourceForm.rdsList.map((rds) => {
          rds.autoCreate = false;
          return null;
        });
      } else if (DataSourceGroup.kafka.indexOf(this.addDataSourceForm.type) > -1) {
        this.addDataSourceForm.rdsList.map((rds) => {
          rds.noAccount = false;
          rds.securityType = this.addDataSourceForm.securityType;
          rds.clientTrustStorePassword = 'KafkaOnsClient';
          return null;
        });
      } else {
        this.addDataSourceForm.rdsList.map((rds) => {
          rds.noAccount = false;
          rds.securityType = this.addDataSourceForm.securityType;
          return null;
        });
      }
    }
    store.state.firstAddDataSource = false;
  },
  data() {
    return {
      store,
      DataSourceGroup,
      Mapping,
      dataSourceColumn: [
        {
          title: this.$t('shi-li-id'),
          key: 'instanceId',
          minWidth: 300,
          render: (h, params) => h('div', {}, `${params.row.instanceDesc}/${params.row.instanceId}`)
        },
        {
          title: this.$t('shu-ju-ku-ren-zheng-fang-shi'),
          slot: 'securityType',
          minWidth: 200
        },
        {
          title: this.$t('shu-ju-ku-zhang-hao-mi-ma'),
          key: '',
          slot: 'account',
          minWidth: 560,
          renderHeader: (h) => h('div', [
            h('span', {
              style: {
                fontFamily: 'PingFangSC-Medium',
                fontWeight: '500'
              }
            }, this.$t('shu-ju-ku-zhang-hao-mi-ma'))
          ])
        }
      ],
      dataSourceColumnWithAkSk: [
        {
          title: this.$t('shi-li-id'),
          key: 'instanceId',
          minWidth: 300,
          render: (h, params) => h('div', {}, `${params.row.instanceDesc}/${params.row.instanceId}`)
        },
        {
          title: this.$t('shu-ju-ku-ren-zheng-fang-shi'),
          slot: 'securityType',
          minWidth: 200
        },
        {
          title: this.$t('shu-ju-ku-zhang-hao-mi-ma'),
          key: '',
          slot: 'account',
          minWidth: 560,
          renderHeader: (h) => h('div', [
            h('span', {
              style: {
                fontFamily: 'PingFangSC-Medium',
                fontWeight: '500'
              }
            }, this.$t('shu-ju-ku-zhang-hao-mi-ma'))
          ])
        },
        {
          title: this.$t('aksk-bi-tian-yong-yu-shu-ju-tong-bu-la-qu-bei-fen-de-ri-zhi-wen-jian'),
          slot: 'aliyunAKSK',
          minWidth: 520,
          renderHeader: (h) => h('div', [
            h('span', {
              style: {
                fontFamily: 'PingFangSC-Medium',
                fontWeight: '500'
              }
            }, this.$t('a-li-yun-accesskey-idaccesskey-secret')),
            h('Tooltip', {
              style: {
                color: '#888888',
                marginLeft: '8px',
                fontWeight: 400
              },
              props: {
                content: this.$t('bi-tian-yong-yu-shu-ju-tong-bu-la-qu-bei-fen-de-ri-zhi-wen-jian'),
                placement: 'right',
                transfer: true
              }
            }, [
              h('Icon', {
                props: {
                  type: 'ios-help-circle-outline'
                }
              })
            ])
          ])
        }
      ],
      dataSourceData: []
    };
  },
  methods: {
    handleChangeAuto(index, data) {
      this.addDataSourceForm.rdsList[index].autoCreate = data;
    },
    handleChangeNoAccount(index, data) {
      this.addDataSourceForm.rdsList[index].noAccount = data;
    },
    handleFileChange(index, e) {
      const files = e.target.files;

      if (files && files[0]) {
        const file = files[0];

        if (file.size > 1024 * 1024) {
          return false;
        }
        this.addDataSourceForm.rdsList[index].securityFile = file;
      }
    },
    handleKeyTabFileChange(e) {
      const files = e.target.files;

      if (files && files[0]) {
        const file = files[0];

        if (file.size > 1024 * 1024) {
          return false;
        }
        this.addDataSourceForm.secretFile = file;
      }
    },
    handleUpdateAddForm() {
      this.addDataSourceForm = { ...this.addDataSourceForm };
    },
    getSecurity(type) {
      let security = {};

      this.securitySetting.map((item) => {
        if (item.securityType === type) {
          security = item;
        }
        return null;
      });
      return security;
    }
  }
};
</script>
<style lang="less" scoped>
.add-datasource-step2 {
  .add-datasouce-title {
    height: 40px;
    line-height: 40px;
    background-color: #ECECEC;
    border-bottom: 1px solid #DADADA;
    padding: 0 20px;
    font-weight: 500;
  }

  .add-datasource-basic {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #DADADA;

    .add-datasource-basic-label {
      width: 10%;
      height: 39px;
      background-color: #F4F4F4;
      padding: 0 10px;
      text-align: right;
      display: inline-block;
      border-right: 1px solid #DADADA;
    }

    .add-datasource-basic-value {
      width: 39.8%;
      padding: 0 10px;
      display: inline-block;
      border-right: 1px solid #DADADA;
    }

    .add-datasource-basic-value:last-child {
      border-right: none;
    }
  }
}

.host-type {
  padding: 12px 0;
}

.host-type-label {
  font-size: 12px;
  color: #333;
  background-color: #DEEFFF;
  display: inline-block;
  //width: 16px;
  height: 16px;
  border-radius: 4px;
  text-align: center;
  line-height: 16px;
  margin-right: 4px;
}
</style>
